var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2167 7.5L13 8.28333L5.43333 15.8333H4.66667V15.0667L12.2167 7.5ZM15.2167 2.5C15.0083 2.5 14.7917 2.58333 14.6333 2.74167L13.1083 4.26667L16.2333 7.39167L17.7583 5.86667C18.0833 5.54167 18.0833 5 17.7583 4.69167L15.8083 2.74167C15.6417 2.575 15.4333 2.5 15.2167 2.5ZM12.2167 5.15833L3 14.375V17.5H6.125L15.3417 8.28333L12.2167 5.15833Z",
    fill: "#2A2B71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.7e89d0cb860c8c9763175697a183136e.svg";
export { ForwardRef as ReactComponent };